module.exports = __webpack_public_path__ + "img/smartbox_new_logo.7d4fb32d.svg";